import { Tenant, UpdateTenant } from "../../Models/Tenant";
import { TenantBootstrap } from "../../Models/TenantBootstrap";
import api from "../axios";

export const tenantService = {
  get: async (): Promise<Tenant> => {
    const response = await api.get('/tenant');
    return response.data;
  },

  getBootstrap: async (): Promise<TenantBootstrap> => {
    const response = await api.get('/tenant/bootstrap');
    return response.data;
  },

  update: async (data: UpdateTenant): Promise<boolean> => {
    const response = await api.patch('/tenant', data);
    return response.data;
  }
};
